import { Location } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-back-button',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
})
export class BackButtonComponent {
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  readonly label = input<string>('Regresar');
  readonly targetRoute = input<string | null>(null);

  onClick(): void {
    const route = this.targetRoute();
    if (route) {
      this.router.navigate([route]);
      return;
    }
    this.location.back();
  }
}
